const tryGetLobbyWrapperWindow = (target: Window): Window | null => {
  try {
    if (target.WebWrapper?.isWrapper?.()) {
      return target;
    }
  } catch {
    // Cross-origin parent (e.g. gc.*:5173) — direct WebWrapper access is not allowed.
  }

  return null;
};

const getLobbyWindow = (): Window | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  let current: Window = window;

  while (current.parent !== current) {
    current = current.parent;
    const wrapperWindow = tryGetLobbyWrapperWindow(current);
    if (wrapperWindow) {
      return wrapperWindow;
    }
  }

  return tryGetLobbyWrapperWindow(window);
};

/** Lobby-installed WebWrapper when embedded in the lobby iframe stack. */
export const getLobbyWebWrapper = (): WebWrapper | null => {
  const lobbyWindow = getLobbyWindow();
  if (!lobbyWindow) {
    return null;
  }

  try {
    return lobbyWindow.WebWrapper?.isWrapper?.()
      ? lobbyWindow.WebWrapper
      : null;
  } catch {
    return null;
  }
};

export const isWebWrapperAvailable = (): boolean =>
  Boolean(getLobbyWebWrapper());

export type WebWrapperSession = {
  jwt: string;
  sessionId: string;
  userId: number;
  loginToken?: string;
};

export type WebWrapperBalance = {
  playableBalance: number;
};

export type WebWrapperContext = {
  embedded: true;
  region: string;
  geocomplyToken?: string;
  loginToken?: string;
};

export type WebWrapper = {
  isWrapper: () => boolean;
  triggerLocateUser: () => Promise<void>;
  triggerLocateUserWithDomain: (domain: string) => Promise<void>;
  getSession: () => Promise<WebWrapperSession | null>;
  getUserId: () => Promise<string | null>;
  getBalance: () => Promise<WebWrapperBalance | null>;
  getContext: () => Promise<WebWrapperContext | null>;
};
